module.exports = __webpack_public_path__ + "img/img4.079cc212.svg";